// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectsBlock_container___qyjR","controls":"ProjectsBlock_controls__pRhE3","toggle":"ProjectsBlock_toggle__yHB7F"};